import HeroSection from './HeroSection';

import {
  Box,
  Container,
  Grid,
  Button,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Paper,
  Typography,
} from "@mui/material";

export default function Homepage() {
  return (
    <Box>
      <HeroSection />
      <Container disableGutters maxWidth={false} sx={{ py: 6 }}>
        <Box sx={{ maxWidth: 'lg', mx: 'auto', px: 2 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Box sx={{ height: 200, backgroundColor: '#eee' }} />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h5" gutterBottom>
                Why Choose McDonald's for Your Next Celebration?
              </Typography>
              <Typography variant="body1" paragraph>
                At McDonald's, we deliver party experiences children will truly enjoy. With colorful themes,
                kid-friendly meals, fun games, and cheerful hosts, every birthday becomes unforgettable. Plus,
                we take care of everything — from setup to clean-up.
              </Typography>
              <Typography variant="h6" gutterBottom>
                Every McDonald's Party Package Includes:
              </Typography>
              <ul>
                <li>Decorated Party Room (festive, age-appropriate fun!)</li>
                <li>McDonald’s Party Host to keep the party running right</li>
                <li>Kid-approved McDonald’s meals and birthday cake</li>
                <li>Fun games, music, and a birthday giveaway for the celebrant</li>
                <li>Invitations and party hats for all guests</li>
                <li>Photo opportunities with McDonald’s characters</li>
              </ul>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container disableGutters maxWidth={false} sx={{ py: 6 }}>
        <Box sx={{ maxWidth: 'lg', mx: 'auto', px: 2 }}>
          <Typography variant="h5" gutterBottom>
            Discover Your Perfect Party Theme!
          </Typography>
          <Typography variant="body1" paragraph>
            From thrilling adventures to dazzling color tales, we have a theme to make every child’s dream celebration
            come true. Explore our popular options and find the perfect fit for your little one!
          </Typography>
          <Grid container spacing={4}>
            {["Happy Party Theme", "Hot Wheels Theme", "Coco Melon Theme"].map((theme) => (
              <Grid item xs={12} sm={6} md={4} key={theme}>
                <Card>
                  <CardMedia
                    sx={{ height: 140, backgroundColor: '#eee' }}
                    title={theme}
                  />
                  <CardContent>
                    <Typography variant="h6">{theme}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus lacinia odio vitae.
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small">See this Theme</Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>

      <Container disableGutters maxWidth={false} sx={{ py: 6 }}>
        <Box sx={{ maxWidth: 'lg', mx: 'auto', px: 2 }}>
          <Typography variant="h5" gutterBottom>
            Your McDonald’s Party in 5 Simple Steps!
          </Typography>
          <ol>
            <li>Pick your location and check for available dates.</li>
            <li>Choose your child’s favorite theme.</li>
            <li>Invite guests and customize your package online.</li>
            <li>Leave the decorations, food, and games to us.</li>
            <li>Show up and enjoy – we’ll handle the clean-up!</li>
          </ol>
        </Box>
      </Container>
      <Container disableGutters maxWidth={false} sx={{ py: 4 }}>
        <Box sx={{ maxWidth: 'lg', mx: 'auto', px: 2 }}>
          <Paper sx={{ p: 3, backgroundColor: '#f2f2f2' }}>
            <Typography variant="body1">
              Need personalized assistance? Our team is ready to help!
            </Typography>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
}